__webpack_require__.p = "/SporeScopeWeb/";